import React from 'react';

const NoCertificateAvailable = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="mb-4">
        <svg 
          className="w-20 h-20 mx-auto text-gray-400" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="1.5" 
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-gray-700 mb-2">
        No Certificates Available
      </h3>
      <p className="max-w-md text-gray-500">
        You haven't completed any courses yet. Certificates will appear here once you successfully complete a course.
      </p>
      <div className="mt-6">
        <a 
          href="/learning/courses" 
          className="px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Explore Courses
        </a>
      </div>
    </div>
  );
};

export default NoCertificateAvailable;